import PizzaTime from "../../images/PizzaTime.jpeg";
import ticket from "../../images/cinema-ticket-1075066.png";
import aws from "../../images/san.jpg";
import mobile from "../../images/whats.png";
import stutech from "../../images/books-5171820.png";
import pizza from "../../images/pizza.jpg";

const ProjectsPreviewData = [
  {
    id: 1,
    img: ticket,
    name: "Ticket booking",
      stack: ["< React.js />", "< CSS3 />",],
    src: "https://631761aaea9ff21f1e2eaa51--benevolent-elf-48978c.netlify.app/",
    source: "https://github.com/San0077/mypro",
    backend:"https://github.com/San0077/hackthon-backend",
    description:
      "You can book your tickets or whatever from wherever you are.You are not required to go in person to the place which is far away from your zone to booking purposes. You can check the availability of the seats or products or anything.It is time saving and quicker than eve",
  },
  {
    id: 2,
    img: aws,
    name: "AWS Polymer search Clone",
    stack: ["< React.js />", "< Node.js />"],
    src: "	https://62ea52db133fea154454ba05--mellifluous-meringue-067647.netlify.app/",
    source: "	https://github.com/San0077/capstone-frontend",
    backend:"https://github.com/San0077/capstone-backend",
    description:
      "I have cloned the AWS polymer search, here you can search what ever like in real AWS ploymer search ",
  },
  {
    id: 3,
    img: stutech,
    name: "Student and teacher Dashboard",
    stack: ["< RESTful API />", "< CSS3 />", "< React.js />"],
    src: "https://preeminent-naiad-e66067.netlify.app/",
    source: "https://github.com/San0077/student-and-teacher-dashboard",
    backend: "https://github.com/San0077/student-teacher-backend",
    description:
      "In this webapplication a student can interact with teacher and a student a get study material from this website and daily class updates , teacher is provideing the new courses to the student",
  },
  {
    id: 4,
    img: mobile,
    name: "Personal Chat app",
    stack: ["< HTML5 />", "< CSS3 />", "< RESTful API />"],
    src: "https://charming-sprinkles-819e65.netlify.app/",
    source: "https://github.com/San0077/chat-frontend",
    backend: "https://github.com/San0077/chat-back",
    description:
      "It is simple personal chating app, Here you can chat with who have the same Room id, the chats are deleted after you disconnected the page and you are safe and secure.",
  },
  {
    id: 5,
    img: pizza,
    name: "Pizza booking app",
    stack: ["< HTML5 />", "< CSS3 />", "< RESTful API />"],
    src: "https://dapper-tulumba-fba556.netlify.app/",
    source: "https://github.com/San0077/pizzab",
    backend: "https://github.com/San0077/pizza-backend",
    description:
      "It is simple pizza booking app You can add and order your pizza which you like in this app you can pay by Google pay option.",
  },
];



export {  ProjectsPreviewData };
